import { render } from "./Home.vue?vue&type=template&id=564aab43"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import exportComponent from "/media/gubbi/51C0A8CA04B85949/Ubuntu/home/tp/e-menu/2.0.0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__